import { defineComponent, PropType } from 'vue';
import emojiList from '_c/config/json/emoticons.json';
import { EmojiItem } from '_c/typings/model/chat';

interface EmojiConfig extends EmojiItem {
  icon: string
}

export default defineComponent({
  name: 'EmotionTextNode',
  props: {
    text: {
      type: String as PropType<string>,
      default: '',
    },
    innerText: {
      type: String as PropType<string>,
      default: '',
    },
    displayText: {
      type: String as PropType<string>,
      default: '',
    },
  },
  data() {
    return {
      iconUrl: '',
    };
  },
  created(): void {
    const target = (emojiList as Array<EmojiConfig>).find(item => item.symbol === this.text);
    if (target?.name) {
      try {
        this.iconUrl = new URL(`../../../../../business/chat/emoji/img/${target.name}.png`, import.meta.url).href;
      } catch (err) {
        //
      }
    }
  },
});
